import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

/** Única ayuda en reposo junto a un control (T2), ≤ 8 palabras (R8); el check `doctrina_de_ux` cuenta su piel
 * fuera de este archivo. Obligatorio para el formato de un campo con validador (R5). */
export function Hint({children, testId, className}: {children: ReactNode; testId?: string; className?: string}) {
  return (
    <p className={cn('text-xs text-muted-foreground', className)} data-testid={testId}>
      {children}
    </p>
  )
}
